import React from 'react';
import styles from './StatsLegend.module.scss';

const StatsLegend = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <ul className={styles['stats-legend']}>
      {items.map((item, idx) => (
        <li
          key={`${item.code}-${idx}`}
          className={styles['stats-legend__item']}
        >
          <span className={styles['stats-legend__code']}>{item.code}:</span>{' '}
          <span className={styles['stats-legend__label']}>{item.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default StatsLegend;
